import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { MenuItem, Typography } from '@material-ui/core'
import PersonAddDisabledIcon from '@material-ui/icons/PersonAddDisabled'

import { CANCEL } from 'app/constants/button'
import { SubscriberMenuAction } from 'app/constants/subscriberCRM'

import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const Reject = (props) => {
  const { closeMenu = () => {}, onAction, selected = [] } = props

  const { formatMessage } = useIntl()
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    closeMenu()
  }

  return (
    <div>
      {
        <MenuItem onClick={() => handleOpen()} className="space-x-5">
          <PersonAddDisabledIcon fontSize="small" className="text-blue-500" />
          <Typography className="text-14 font-400 text-blue-500">
            {formatMessage({
              id: 'subscriber.reject',
            })}
          </Typography>
        </MenuItem>
      }

      <SubmitDialog
        id="dialog-reject-subscriber"
        open={isOpen}
        type={CANCEL}
        title={formatMessage({
          id: 'subscriber.reject.title',
        })}
        description={formatMessage({
          id: 'subscriber.reject.description',
        })}
        submitText={formatMessage({
          id: 'subscriber.reject',
        })}
        onSubmit={() => {
          onAction(SubscriberMenuAction.REJECT, selected)
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </div>
  )
}

Reject.propTypes = {
  onAction: PropTypes.func,
  selected: PropTypes.array,
  closeMenu: PropTypes.func,
}

export default Reject
